import Vue from 'vue'
import Router from 'vue-router'
import globalVariable from '../api/global/globalVariable';
import {
  login
} from '@/api/login.js'

// pharmacistType 药师类型 1-药厂药师 2-医院药师
let pharmacistType = localStorage.getItem("pharmacistType");
let channel = localStorage.getItem("channel");

let isManager = '';
let isTransfer = '';
if(!!channel) {
  channel = JSON.parse(channel)
  console.log("channelCode", channel, channel.channelCode, process.env.NODE_ENV)
  isManager = channel.isManager;
  isTransfer = channel.isTransfer;
}

let drugPharmacyMange = true;  // 药房管理
if (isManager == 1) {
  drugPharmacyMange = false;
}

let pharmaceuticalFactory = true;   // 药厂药师
let hospital = true;    // 医院药师
let isTransferFlag = true; // 是否中转药厂 0-否 1-是
if(isTransfer == 1) {
  pharmaceuticalFactory = true;
  hospital = true;
  isTransferFlag = false;
} else if(pharmacistType == 1) {
  pharmaceuticalFactory = false;
  hospital = true;
  isTransferFlag = true;
} else if(pharmacistType == 2) {
  pharmaceuticalFactory = true;
  hospital = false;
  isTransferFlag = true;
}

console.log(isTransfer, pharmacistType)

globalVariable.isTransferFlag = isTransferFlag

console.log(pharmaceuticalFactory, hospital, isTransferFlag, )

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: !isTransferFlag ? '/oms' : '/home',
    hidden: pharmaceuticalFactory && hospital,
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
  {
    path: '/approval',
    component: Layout,
    redirect: '/approval',
    hidden: pharmaceuticalFactory || channel.assessmentType == 2,  // 药厂药师 在此基础上，再看药厂配置是否无需审核
    children: [{
      path: 'approval',
      name: 'approval',
      component: () => import('@/views/approval/approval'),
      meta: { title: '审核处方订单', icon: 'order' }
    },
    {
      path: 'approvalInfo',
      name: 'approvalInfo',
      component: () => import('@/views/approval/approvalInfo'),
      meta: { title: '订单详情' },
      hidden: true
    },]
  },
  {
    path: '/drug',
    component: Layout,
    redirect: '/drugList',
    hidden: pharmaceuticalFactory,
    children: [{
      path: 'drugList',
      name: 'drugList',
      component: () => import('@/views/drug/drugList'),
      meta: { title: '药品预警值设置', icon: 'order' }
    }
   ]
  },
  // {
  //   path: '/prescribe',
  //   component: Layout,
  //   redirect: '/openPrescribe',
  //   hidden: isTransferFlag,
  //   children: [{
  //     path: 'openPrescribe',
  //     name: 'openPrescribe',
  //     component: () => import('@/views/prescriptions/prescriptionsGeneration'),
  //     meta: { title: '录入处方', icon: 'order' }
  //   }
  //  ]
  // },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '药房订单管理', icon: 'order' },
    hidden:  !hospital,
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/ordersToBeShipped'),
        meta: { title: '待发货订单', icon: 'product-list' },
      },
      {
        path: 'selfRetrieval',
        name: 'selfRetrieval',
        component: () => import('@/views/oms/order/ordersSelfRetrieval'),
        meta: { title: '待自取订单', icon: 'product-list' },
      },
      {
        path: 'ordersSendOutGoods',
        name: 'ordersSendOutGoods',
        component: () => import('@/views/oms/order/ordersSendOutGoods'),
        meta: { title: '已发货订单', icon: 'product-list' }
      },
      {
        path: 'ordersCompleted',
        name: 'ordersCompleted',
        component: () => import('@/views/oms/order/ordersCompleted'),
        meta: { title: '已完成订单', icon: 'product-list' }
      },
      {
        path: 'ordersRefunded',
        name: 'ordersRefunded',
        component: () => import('@/views/oms/order/ordersRefunded'),
        meta: { title: '已退款订单', icon: 'product-list' }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        path: 'openPrescribe',
        name: 'openPrescribe',
        component: () => import('@/views/prescriptions/prescriptionsGeneration'),
        meta: { title: '录入处方'},
        hidden: true
      }
    ]
  },
  {
    path: '/cloudPharmacyDispensing',
    component: Layout,
    redirect: '/cloudPharmacyDispensing/send',
    name: 'cloudPharmacyDispensing',
    meta: { title: '云药房发药', icon: 'order' },
    hidden: hospital,
    children: [
      {
        path: 'send',
        name: 'send',
        component: () => import('@/views/cloudPharmacyDispensing/send'),
        meta: { title: '协定方发药', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'sendList',
        name: 'sendList',
        component: () => import('@/views/cloudPharmacyDispensing/sendList'),
        meta: { title: '发药列表', icon: 'product-list' },
      },
      {
        path: 'agreementPartyOrderDetail',
        name: 'agreementPartyOrderDetail',
        component: () => import('@/views/cloudPharmacyDispensing/agreementPartyOrderDetail'),
        meta: { title: '订单详情', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'therapeuticRegimenCommit',
        name: 'therapeuticRegimenCommit',
        component: () => import('@/views/cloudPharmacyDispensing/therapeuticRegimenCommit'),
        meta: { title: '治疗列表', icon: 'product-list' },
      },
      {
        path: 'createPlan',
        name: 'createPlan',
        component: () => import('@/views/cloudPharmacyDispensing/createPlan'),
        meta: { title: '治疗方案', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'treatmentsPlanDetail',
        name: 'treatmentsPlanDetail',
        component: () => import('@/views/cloudPharmacyDispensing/treatmentsPlanDetail'),
        meta: { title: '治疗方案详情', icon: 'product-list' },
        hidden: true
      },
    ]
  },

  // 只有汉沽存在的药房管理
  {
    path: '/drugChannelManage',
    component: Layout,
    // redirect: '/drugChannelManage/drugManagement',
    name: 'drugChannelManage',
    meta: { title: '药房管理', icon: 'order' },
    hidden: drugPharmacyMange,
    children: [
      {
        path: 'drugManagement',
        name: 'drugManagement',
        component: () => import('@/views/drugChannelManage/drugManagement/drugManagement'),
        meta: { title: '药品管理', icon: 'product-list' },
      },
      {
        path: '/drugManagement/drugDetail',
        name: 'drugDetail',
        component: () => import('@/views/drugChannelManage/drugManagement/drugDetail'),
        meta: {
          title: '新增药品',
          icon: 'product-list'
        },
        hidden: true,
      },
      {
        path: '/drugManagement/updateDrugDetail',
          name: 'updateDrugDetail',
        component: () => import('@/views/drugChannelManage/drugManagement/updateDrugDetail'),
        meta: {
        title: '修改药品',
          icon: 'product-list'
        },
        hidden: true,
      },
      {
        path: 'drugOrder',
        name: 'drugOrder',
        component: () => import('@/views/drugChannelManage/drugOrder/drugOrder'),
        meta: { title: '订单管理', icon: 'product-list' },
      },
      {
        path: '/drugChannelManage/drugOrderDetail',
        name: 'drugOrderDetail',
        component: () => import('@/views/drugChannelManage/drugOrder/drugOrderDetail'),
        meta: {
          title: '药品订单详情',
          icon: 'product-list'
        },
        hidden: true,
      }
    ]
  },
  // {
  //   path: '/demo',
  //   component: Layout,
  //   redirect: '/demo/demoManager',
  //   name: 'demo',
  //   meta: {
  //     title: 'DEMO',
  //     icon: 'order'
  //   },
  //   children: [{
  //       path: 'demoPage',
  //       name: 'demoPage',
  //       component: () => import('@/views/demo/demoManager/demoPage'),
  //       meta: {
  //         title: '列表页面demo',
  //         icon: 'product-list'
  //       },
  //     },
  //     {
  //       path: 'otherPage',
  //       name: 'otherPage',
  //       component: () => import('@/views/demo/demoManager/demoPage'),
  //       meta: {
  //         title: '列表页面。。。',
  //         icon: 'product-list'
  //       },
  //     },
  //     {
  //       path: 'demoDetail',
  //       name: 'demoDetail',
  //       component: () => import('@/views/demo/demoManager/demoDetail'),
  //       meta: {
  //         title: '详情页面demo'
  //       },
  //       hidden: true
  //     },
  //   ]
  // },
  { path: '*', redirect: '/404', hidden: true }
]

let route = new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

// router.beforeEach((to, from, next) => {
//   login
// })

export default route



// WEBPACK FOOTER //
// ./src/router/index.js